interface Scope {
  setContext: (key: string, context: Record<string, unknown> | null) => unknown
}

let captureException: ((error: unknown) => void) | null = null
let withScope: ((callback: (scope: Scope) => void) => void) | null = null

if (process.env.NODE_ENV === "production") {
  const sentry = require("@sentry/react")
  captureException = sentry.captureException
  withScope = sentry.withScope
}

export function log(error: unknown, context?: Record<string, unknown>): void {
  if (captureException && withScope) {
    const capture = captureException
    withScope(scope => {
      if (context) {
        scope.setContext("react", context)
      }
      capture(error)
    })
  }
  console.log(error)
}
